/**
 * CVO Officers View
 * Dedicated route component for CVO officers management
 */

import React from 'react';
import { OfficersView } from './index';
import { useNavigate } from 'react-router-dom';

const CVOOfficersView = () => {
  const navigate = useNavigate();

  const handleOfficerCasesClick = (officer) => {
    // Navigate to complaints view with officer filter
    navigate('/cvo-dashboard/complaints', { 
      state: { filterOfficer: officer.name } 
    });
  };

  return (
    <OfficersView
      onOfficerCasesClick={handleOfficerCasesClick}
    />
  );
};

export default CVOOfficersView;
